/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import postedAt from '../utils/index';
import Image from '../styled/Image';
import UserInfoContainer from '../styled/UserInfoContainer';

function UserInfo({
  avatar, name, createdAt, category,
}) {
  return (
    <UserInfoContainer>
      <Image src={avatar} alt={name} />
      <div className="thread-item__user-info">
        <p className="thread-item__user-name">{name}</p>
        <p className="thread-item__posted-at">
          Posted
          {' '}
          {postedAt(createdAt)}
          {category && (
            <>
              {' '}
              in
              {' '}
              <span>{category}</span>
            </>
          )}
        </p>
      </div>
    </UserInfoContainer>
  );
}

UserInfo.propTypes = {
  createdAt: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
};

export default UserInfo;
